var defaultConf = require('./config-default');

var BO_URL = 'nautic2022-data.ms-dev.mobile-spot.com';
var NODE_BACKEND_DOMAIN = 'nautic-node-backend-dev.mobile-spot.com';
var NODE_WS_BAKEND_DOMAIN = 'nautic-node-backend-ws-dev.mobile-spot.com';
module.exports = require('deepmerge')(defaultConf, {
  ENV: 'dev',
  BO_URL: BO_URL,
  // no trailing '/'
  BO_PATH: '/home/legacy/fin/nautic/nautic2022/nautic2022-data.ms-dev.mobile-spot.com',
  BO_SERVER_ALIAS: 'ms-dev.mobilespot.prodleni.local',
  BO_SSH_USER: 'legacy',
  BO_SSH_PORT: '22',
  DEPLOY_PATH: '/home/legacy/fin/nautic/nautic2022/nautic2022.ms-dev.mobile-spot.com',
  GOOGLE_ANALYTICS_ID: 'UA-245495660-2',
  projectId: '1017555973100',
  // FCM sender id
  appId: '9C686-109FC',
  // pushwoosh appid
  SEND_EXPORTED_NOTES_MAIL: {
    WS_URL: 'http://localhost:3096/api/exportNotesByMail',
    EXPEDITOR: 'no-reply@mobile-spot.com',
    KEY: 'zpgZkgiz845gjzFzi'
  },
  ADDITIONAL_DEFAULTSRC_CSP: (Array.isArray(defaultConf.ADDITIONAL_DEFAULTSRC_CSP) ? defaultConf.ADDITIONAL_DEFAULTSRC_CSP : []).concat([]),
  CHECK_NETWORK_URL: "https://".concat(BO_URL, "/online.txt"),
  SYNCHRONIZED_FAVORITES: {
    MODE: 'peering',
    // (peering or login)
    URL: "".concat(NODE_BACKEND_DOMAIN, "/synchro-favorites") //`https://${NODE_BACKEND_DOMAIN}/synchro-favorites`,

  },
  REAL_TIME: {
    URL: "https://".concat(NODE_WS_BAKEND_DOMAIN)
  },
  SSO: {
    SSO_REQUEST_URL: "".concat(NODE_BACKEND_DOMAIN, "/sso-request") //`https://${NODE_BACKEND_DOMAIN}/sso-request`,

  },
  SOCIAL: {
    URL: "".concat(NODE_BACKEND_DOMAIN, "/social") //`https://${NODE_BACKEND_DOMAIN}/social`,

  },
  SECURED_PDF: {
    SECURED_PDF_REQUEST_URL: "".concat(NODE_BACKEND_DOMAIN, "/secured-pdf-viewer") // `https://${NODE_BACKEND_DOMAIN}/secured-pdf-viewer`, // 

  },
  PUBLIC_PDF: {
    PUBLIC_PDF_REQUEST_URL: "".concat(NODE_BACKEND_DOMAIN, "/public-pdf-viewer") // `https://${NODE_BACKEND_DOMAIN}/public-pdf-viewer`

  },
  CONTRIBUTIONS_FEED: {
    URL: "".concat(NODE_BACKEND_DOMAIN, "/contributions-feed") // `https://${NODE_BACKEND_DOMAIN}/contributions-feed`,

  }
});
;